import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Logger } from "../../infra/logger/logger";
import { TripInputFilter } from "domain/models/trip-input-filter";
import tripRepository from "infra/repositories/trip-repository";
import { Trip } from "domain/entities/trip";

export const useTripsByFilter = (filter: TripInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["trips", filter],
    queryFn: async () => {
      try {
        const result = await tripRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    enabled: !!filter.tripsheetId,
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: Number(process.env.REACT_APP_QUERY_STALE_TIME_SHORT) || 0,
  });
};


export const useUpdateTripMutation = () => {
  const logger = Logger.getInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Trip) => {
      const result = await tripRepository.update(data);
      return result;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["trips", {}] });
    },
    onError: (error: any) => {
      if (error instanceof AxiosError) {
        logger.error(
          error.response?.data.metadata.errors[0],
          error.response?.data.metadata
        );
      }
    },
  });
};

